var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8575 0.5H10.1432C12.46 0.5 13.75 1.835 13.75 4.1225V11.87C13.75 14.195 12.46 15.5 10.1432 15.5H3.8575C1.5775 15.5 0.25 14.195 0.25 11.87V4.1225C0.25 1.835 1.5775 0.5 3.8575 0.5ZM4.06011 3.995V3.9875H6.30185C6.6251 3.9875 6.8876 4.25 6.8876 4.57175C6.8876 4.9025 6.6251 5.165 6.30185 5.165H4.06011C3.73686 5.165 3.47511 4.9025 3.47511 4.58C3.47511 4.2575 3.73686 3.995 4.06011 3.995ZM4.06011 8.555H9.9401C10.2626 8.555 10.5251 8.2925 10.5251 7.97C10.5251 7.6475 10.2626 7.38425 9.9401 7.38425H4.06011C3.73686 7.38425 3.47511 7.6475 3.47511 7.97C3.47511 8.2925 3.73686 8.555 4.06011 8.555ZM4.06002 11.9825H9.94002C10.2393 11.9525 10.465 11.6968 10.465 11.3975C10.465 11.09 10.2393 10.835 9.94002 10.805H4.06002C3.83502 10.7825 3.61752 10.8875 3.49752 11.0825C3.37752 11.27 3.37752 11.5175 3.49752 11.7125C3.61752 11.9 3.83502 12.0125 4.06002 11.9825Z",
    fill: "#0A3400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/coupons.58fae92a92c757394e6ec74723eb4dde.svg";
export { ForwardRef as ReactComponent };